import {SxType} from "@baseTypes/sx/sxTypes";
import {
    SV_DARK,
    SV_LIGHT,
    SV_RADIUS_MD,
    SV_TRANSITION,
    svPressable
} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    root: {
        boxShadow: 'none',
        padding: '8px 18px',
        borderRadius: SV_RADIUS_MD,
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '18px',
        letterSpacing: 0,
        textTransform: 'none',
        minWidth: '140px',
        minHeight: 'auto',
        transition: SV_TRANSITION,
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.accent,
            color: SV_LIGHT.accentText,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.accent,
            color: SV_DARK.accentText,
        },
        ...svPressable,
        '&:hover': {
            ...svPressable['&:hover'],
            boxShadow: '0 6px 16px rgba(69, 116, 212, 0.28)',
            '.lightTheme &': {
                backgroundColor: SV_LIGHT.accentHover,
            },
            '.darkTheme &': {
                backgroundColor: SV_DARK.accentHover,
            },
        },
        '&.secondary, &.secondary:hover': {
            boxShadow: 'none',
            '.lightTheme &': {
                backgroundColor: SV_LIGHT.accentSoft,
                color: SV_LIGHT.accent,
            },
            '.darkTheme &': {
                backgroundColor: SV_DARK.accentSoft,
                color: SV_DARK.accentHover,
            },
        },
        '&.secondary:hover': {
            '.lightTheme &': {
                backgroundColor: 'rgba(69, 116, 212, 0.2)',
                color: SV_LIGHT.accentHover,
            },
            '.darkTheme &': {
                backgroundColor: 'rgba(91, 138, 224, 0.28)',
            },
        },
        '&.Mui-disabled': {
            opacity: 0.45,
            '.lightTheme &': {
                backgroundColor: SV_LIGHT.accent,
                color: SV_LIGHT.accentText,
            },
            '.darkTheme &': {
                backgroundColor: SV_DARK.accent,
                color: SV_DARK.accentText,
            },
        },
    }
}
